import { Link } from 'react-router-dom';
import ArticleHeader from './components/ArticleHeader';
import ArticleBody from './components/ArticleBody';
import Footer from '@/pages/home/components/Footer';

declare const __VITE_SITE_URL__: string;

const pageTitle = 'Understanding PandabuySpreadsheet: The 2026 Curated Guide';
const pageDescription = 'Your complete resource for mastering PandabuySpreadsheet — from getting started to becoming a power user. Learn how curated product lists can transform your shopping experience, save you hours of manual searching, and discover hidden gems across every fashion category.';
const pageKeywords = 'pandabuy spreadsheet, curated shopping, fashion discovery, product list, trending finds, budget fashion, streetwear, sneakers';
const canonicalUrl = 'https://pandabuy.bar/pandabuy-sheet-ultimate-guide';
const ogImage = 'https://readdy.ai/api/search-image?query=Organized%20digital%20spreadsheet%20displayed%20on%20laptop%20screen%20alongside%20curated%20fashion%20items%20on%20minimal%20desk%2C%20soft%20afternoon%20light%20through%20window%20blinds%2C%20editorial%20workspace%20photography%2C%20warm%20taupe%20and%20cream%20interior%2C%20productive%20organized%20aesthetic&width=1200&height=630&seq=ultimate-guide-og&orientation=landscape';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: pageTitle,
  description: pageDescription,
  image: ogImage,
  url: canonicalUrl,
  datePublished: '2026-06-10',
  dateModified: '2026-07-01',
  author: { '@type': 'Organization', name: 'pandabuy.bar' },
  publisher: { '@type': 'Organization', name: 'pandabuy.bar', url: 'https://pandabuy.bar' },
  mainEntityOfPage: { '@type': 'WebPage', '@id': canonicalUrl },
};

export default function ArticlePage() {
  return (
    <>
      <title>{pageTitle} | pandabuy.bar</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={`${pageTitle} | pandabuy.bar`} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${pageTitle} | pandabuy.bar`} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={ogImage} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      <nav className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="font-heading text-xl font-bold text-foreground-950 tracking-tight whitespace-nowrap"
            >
              pandabuy<span className="text-primary-500">.</span>bar
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </nav>
      <main>
        <ArticleHeader />
        <ArticleBody />
      </main>
      <Footer />
    </>
  );
}